import axios from "axios";

const ProductionMonitorService = {
  GetIwoList: () =>
    axios.get("PreFabMonitor/GetIwoList"),

  InsertFrame: (payload) => {
    const body = new URLSearchParams();
    body.append("iwoNo", payload.iwoNo);
    body.append("componentName", payload.componentName);
    body.append("frameNo", payload.frameNo);
    body.append("startDate", payload.startDate);
    body.append("endDate", payload.endDate);
    body.append("weight", payload.weight);
    body.append("createdBy", payload.createdBy);


    payload.partNos.forEach((partNo) => body.append("partNos", partNo));

    return axios.post("PreFabMonitor/InsertFrame", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },


  // Same way as InsertFrame (form data, no CORS error)
  DeleteFrame: (payload) => {
    const body = new URLSearchParams();
    body.append("frameId", payload.frameId);
    body.append("deletedBy", payload.deletedBy);

    return axios.post("PreFabMonitor/DeleteFrame", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  GetDelayReasons: () =>
    axios.get("PreFabMonitor/GetDelayReasons"),

  // iwoNo optional: GetFrameDetails?iwoNo=10086 -> only that IWO's frames
  GetFrameDetails: (iwoNo) =>
    axios.get("PreFabMonitor/GetFrameDetails", iwoNo ? { params: { iwoNo } } : undefined),


  InsertDailyRemark: (payload) => {
    const body = new URLSearchParams();
    body.append("frameId", payload.frameId);
    body.append("workDate", payload.workDate);
    body.append("remark", payload.remark);
    body.append("lostHoursDts", payload.lostHoursDts);
    body.append("lostHoursCdl", payload.lostHoursCdl);
    body.append("dtsDelayReason", payload.dtsReason);
    body.append("dtsRemark", payload.dtsRemark);
    body.append("cdlDelayReason", payload.cdlReason);
    body.append("cdlRemark", payload.cdlRemark);
    body.append("createdBy", payload.createdBy);

    return axios.post("PreFabMonitor/InsertDailyRemark", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  // Same way as InsertFrame (form data, no CORS error)
  UpdatePhysicalCompletion: (payload) => {
    const body = new URLSearchParams();
    body.append("frameId", payload.frameId);
    body.append("physicalCompletion", payload.physicalCompletion);
    body.append("updatedBy", payload.updatedBy);

    return axios.post("PreFabMonitor/UpdatePhysicalCompletion", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  // Only frameId, updatedBy and the changed fields are sent.
  // Parts go as parts[0].partId / parts[0].partNo (partId "" = new part)
  UpdateFrame: (payload) => {
    const body = new URLSearchParams();
    body.append("frameId", payload.frameId);

    ["iwoNo", "componentName", "frameNo", "startDate", "endDate", "weight"].forEach((key) => {
      if (payload[key] !== undefined) body.append(key, payload[key]);
    });

    (payload.parts || []).forEach((p, i) => {
      body.append(`parts[${i}].partId`, p.partId);
      body.append(`parts[${i}].partNo`, p.partNo);
    });

    body.append("updatedBy", payload.updatedBy);

    return axios.post("PreFabMonitor/UpdateFrame", body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};

export default ProductionMonitorService;